<template>
  <div id="app">
    <div>
      <!-- 头部路由tab -->
      <Header id="mainHeader"></Header>
      <!-- 头部路由tab -->


      <!-- 主体内容 -->
      <div id="mainView">

        <div class="queryFixed" id="myElement">

          <div v-show="fold" class="fold">
            <i class="el-icon-d-arrow-left" style="margin-bottom: 10px"></i>
            <p>快捷功能</p>
          </div>
          <div v-show="!fold" class="unfold">

            <div
              style="display: flex;justify-content: space-around;align-items: center;font-size:18px; margin-bottom: 10px">
              <p style="margin-right: 10px">快捷功能</p>
              <i class="el-icon-d-arrow-right"></i>
            </div>
            <el-button type="primary" @click="queryScore" class="btn">查询成绩</el-button>
            <!-- <el-button type="primary" @click="orgFunction" class="btn">组织功能平台</el-button> -->
          </div>
        </div>
        <!-- <div class="unfold" >
        <i class="el-icon-d-arrow-left" style="margin-bottom: 10px"></i>
        <p>快捷功能</p>
      </div> -->
        <div class="queryFixedTwo" @click="goTopNone">
          <i class="el-icon-arrow-up"></i>
        </div>
        <router-view>
        </router-view>
      </div>

      <!-- 主体内容 -->

      <!-- 底部信息 -->
      <Footer id="mainFooter"></Footer>
      <!-- 底部信息 -->
    </div>
    <!-- 查询成绩得弹窗 -->
    <el-dialog title="查询成绩" :visible.sync="scoreVisible" :close-on-click-modal="false" center width="40%"
      @close="cancel">
      <div style="display: flex; justify-content: center">
        <div>
          <div style="margin-left: 130px; color: rgb(245, 108, 108); margin-bottom: 20px">暂时只支持市等级赛事查询</div>
          <el-form :model="form" label-width="130px" :rules="rules" ref="form">
            <el-form-item label="赛事名称" prop="name">
              <el-select clearable v-model="form.name" placeholder="请选择赛事">
                <el-option v-for="item in nameOptions" :key="item.matchId
" :label="item.matchName" :value="item.matchId
">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="参赛人身份证号" prop="number">
              <el-input v-model="form.number" autocomplete="off" placeholder="填写身份证号"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitQuery">查 询</el-button>
        <el-button @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 成绩展示弹窗 -->
    <el-dialog title="查询成绩" :visible.sync="scoreDisplayVisible" :close-on-click-modal="false" center width="40%">
      <div style="display: flex; justify-content: center" v-if="playerInfo">
        <div class="table">
          <!-- 第一行 -->
          <div class="row">
            <div class="cell">赛事名称：</div>
            <div class="cell">{{ playerInfo.matchName}}</div>
          </div>
          <!-- 剩余行... -->
          <!-- 第二行 -->
          <div class="row">
            <div class="cell">参赛人姓名：</div>
            <div class="cell">{{ playerInfo.realName}}</div>
          </div>
          <!-- 第三行 -->
          <div class="row">
            <div class="cell">参赛组别：</div>
            <div class="cell">{{ playerInfo.groupName}}</div>
          </div>
          <!-- 第四行 -->
          <div class="row">
            <div class="cell">成绩：</div>
            <div class="cell">{{ playerInfo.score}}</div>
          </div>
          <!-- 第五行 -->
          <div class="row">
            <div class="cell">排名：</div>
            <div class="cell">{{ playerInfo.ranking}}</div>
          </div>
        </div>
      </div>
      <div v-else style="display: flex; justify-content: center; color: red">
        未查到参赛选手！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="scoreDisplayVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import './assets/css/base.css'
  import Footer from '@/components/Footer'
  import Header from '@/components/Header'
  export default {
    components: {
      Footer,
      Header
    },
    data() {
      var validateidCardNo = (rule, value, callback) => {
        let str = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (value === '') {
          callback(new Error('请输入身份证号码'));
        } else if (str.test(value) == false) {
          callback(new Error('请输入正确的身份证号码'));
        } else {
          callback();
        }
      }
      return {
        num: 1, //控制路由参数 每次点击都发生变化
        // deptId: 100,
        fold: true, //快捷功能是折叠的
        scoreDisplayVisible: false,
        scoreVisible: false,
        form: {
          name: '',
          number: ''
        },
        nameOptions: [],
        rules: {
          // 表单数据校验规则
          name: [{
            required: true,
            message: '请选择赛事',
            trigger: 'blur'
          }],
          // 短信验证码
          number: [{
            validator: validateidCardNo,
            trigger: 'blur'
          }]
        },
        playerInfo: {}
      }
    },
    created() {
      // this.getDeptId()
      this.getmovedata()
      this.getAboutData()
    },
    mounted() {
      // this.$forceUpdate()
      // 获取元素  
      var element = document.getElementById('myElement');
      var vm = this; // 保存对 Vue 实例的引用  
      // 添加 mouseenter 事件监听器  
      element.addEventListener('mouseenter', function (event) {
        console.log('鼠标进入了元素', event.target);
        vm.fold = false
        console.log(vm.fold);
      });
      // 添加 mouseleave 事件监听器  
      element.addEventListener('mouseleave', function (event) {
        console.log('鼠标离开了元素', event.target);
        vm.fold = true
        console.log(vm.fold);
      });



    },
    methods: {
      async getmovedata() {
        // 请求列表数据
        const {
          data
        } = await request({
          method: 'get',
          url: `/pub/match/list`,
          params: {
            pageSize: 999, //每页条目数
            pageNum: 1, // 当前页码
          },
        })
        // 将请求返回的列表数据赋值给newslist
        this.nameOptions = data.rows
      },
      queryScore() {
        this.scoreVisible = true
      },
      orgFunction() {

      },
      // 确定查询
      submitQuery() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // 验证通过  
            // 调用接口  
            this.queryList()
          } else {
            // 验证不通过  
            return false;
          }
        });
      },
      cancel() {
        this.scoreVisible = false
        this.form = {
          name: '',
          number: ''
        }
        this.$refs['form'].clearValidate();
      },
      // resetForm(formName) {
      //   this.$refs[formName].resetFields();
      // }
      async queryList() {
        // 请求列表数据
        const {
          data
        } = await request({
          method: 'get',
          url: `/pub/match/player/list`,
          params: {
            pageSize: 10, //每页条目数
            pageNum: 1, // 当前页码
            matchId: this.form.name,
            idCard: this.form.number
          },
        })
        this.playerInfo = data.rows[0]
        this.cancel()
        this.scoreDisplayVisible = true
        // 跳转至赛事活动页  
        // this.num = parseInt(Math.random() * 1000)
        // this.$router.push({
        //   name: "move",
        //   query: {
        //     queryRandomNum: this.num
        //   }
        // })
        // this.$store.commit("updatetabIndexActive", "3")
      },
      goTopNone() {
        document.documentElement.scrollTop = 0
      },
      // 获取新闻资讯列表
      async getAboutData() {
        try {
          // 请求列表数据
          const {
            data
          } = await request({
            method: "GET",
            url: `/common/about`,
          })
          if (data.code == 200) {
            this.aboutData = data.data
            this.$store.commit("updateAboutData", data.data)
          } else {
            if (data.msg) {
              this.$message(data.msg);
              return
            }
            this.$message("提交失败,请重试")
          }
        } catch (error) {
          this.$message("数据请求失败，请重试")
        }

      },
    }
  }

</script>
<style lang="less" scoped>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #mainHeader {
    // min-width: 1903px;  //待确认设置最小宽度是否可行  可能会造成部分用户电脑出现滚动条
    min-width: 1230px;
    background-color: #F0F0F0;
    // min-width: 100vw;  
  }

  #mainView {
    min-width: 1230px;
    // min-width: 100vw;  //最小宽度  待确认是否可行
    // background-color: #EFEFEF;
    background-color: #F0F0F0;
    // background-image:url("https://csdnimg.cn/release/blogv2/dist/pc/themesSkin/skin-whitemove/images/bg.gif") !important
    // background-image:url("") !important
  }

  #mainFooter {
    min-width: 1230px;
    // min-width: 100vw;    //最小宽度  待确认是否可行
    background: #333333;
  }

  .router-view {
    z-index: -999;
  }

  .queryFixed,
  .queryFixedTwo {
    width: 40px;
    padding: 10px;

    top: 320px;
    right: 0px;
    border-radius: 10px 0px 0px 10px;
    z-index: 1000;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    color: #000;
    font-size: 16px;
    cursor: pointer;
    -webkit-transition: background-color 0.8s, font-size 0.4s, -webkit-transform 1s;
    /* For Safari 3.1 to 6.0 */
    transition: background-color 0.8s, padding-right 0.5s, padding-left 0.5s, transform 2s;
  }

  .queryFixed {
    height: 160px
  }

  .queryFixed:hover {
    width: 200px;
    // background-color: #FE80B1;
    opacity: 1;
    // padding-right: 100px;
    // padding-left: 100px;
    display: flex;
    flex-direction: row;
  }

  .unfold {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .btn {
      width: 140px;
      margin-bottom: 10px
    }

    /deep/.el-button+.el-button,
    .el-checkbox.is-bordered+.el-checkbox.is-bordered {
      margin-left: 0;
    }
  }

  .queryFixedTwo:hover {
    background-color: #76AFEC;

    // background-color: #FE80B1;
    padding-right: 25px;
    padding-left: 25px;
  }

  .queryFixedTwo {
    top: 500px;

    i {
      font-weight: bold;
      font-size: 22px;
    }

  }

  .table {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* 或者设置为你需要的宽度 */
    margin-bottom: 100px;
    border: 1px solid #ccc;

    .row {
      display: flex;
      justify-content: space-between;
      /* 使单元格内容水平对齐 */
      border-bottom: 1px solid #ccc;
      /* 添加底部边框 */
    }

    .row:last-child {
      border-bottom: none;
      /* 移除最后一行的底部边框 */
    }

    .cell {
      flex: 1;
      /* 使单元格占据等量的空间，除非设置了具体的宽度 */
      padding: 10px;
      /* 添加内边距，使内容看起来不紧贴边框 */
      border-right: 1px solid #ccc;
      /* 添加右边框 */
    }

    .cell:last-child {
      border-right: none;
      /* 移除最后一个单元格的右边框 */
    }

  }

</style>
